import { databaseService } from '../offline/DatabaseService';

class ContractDataService {
  // Placeholder for contract-related data operations
  public async getCachedContracts(): Promise< { Id: number; Name: string }[]> {
    try {
      const cachedContracts = await databaseService.select('cached_contracts', '1=1', []);
      return cachedContracts.map((row: any) => ({
        Id: row.contract_id,
        Name: row.name
      }));
    } catch (error) {
      console.error('Error fetching cached contracts:', error);
      return [];    
    }
  }
}

export const contractDataService = new ContractDataService();
export default contractDataService;